<template>
<div class="vliveGuideCover">
    <div>
        <!--<el-switch v-model="guideCover.isopencover" @change="switchStatus" active-text="功能开启后，观看端首次进入会出现引导封面"></el-switch>-->
        <span class="switch"  @click.stop="switchStatus">
            <el-switch v-model="guideCover.isopencover" active-text="功能开启后，观看端首次进入会出现引导封面" disabled></el-switch>
        </span>
    </div>
    <div class="guide-cover" v-if="guideCover.isopencover">
        <div class="upload cover-image">
            <div class="avatar-uploader" @click="openLocalGallery">
                <div class="el-upload el-upload--text">
                    <i class="el-icon-plus avatar-uploader-icon icon_upload" v-if="!guideCover.coverPicture.furl"></i>
                    <img :src="guideCover.coverPicture.furl + '?' + timestamp" alt="" class="avatar" v-if="guideCover.coverPicture.furl">
                </div>
            </div>
        </div>
        <div class="el-upload__tip">建议像素：750（宽）*1206（高），JPG、PNG格式，大小不超过5M。</div>
    </div>
    <localCropper :cropperOption="cropperOption" ref="localCropper" @setImage="_editGuideCover" :uploadType="uploadType"></localCropper>
</div>
</template>

<script>
import LocalCropper from 'base/cropper/localCropper'
import {mapGetters, mapActions} from 'vuex'
import {editVliveGuideCoverStatus, editVliveGuideCover} from 'api/api'
import {formatFileInfo} from 'common/js/tools'
export default {
    name: 'vliveGuideCover',
    data() {
        return {
            timestamp: new Date().getTime(), // 时间戳
            guideCover: {
                isopencover: false,
                coverPicture: {
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimeType: '',
                    objecttype: '',
                    furl: ''
                }
            },
            cropperOption: {
                fixedNumber: [750, 1206], // 截图框的宽高比例
                enlarge: 5, // 图片根据截图框输出比例倍数
                autoCropWidth: 150, // 默认生成截图框宽度
                autoCropHeight: 241.2 // 默认生成截图框高度
            },
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            settingType: 'isopencover' // isopenpreview 预告片 isopencover 引导封面 isopenmp 关注公众号 isopenenroll 报名
        }
    },
    mounted() {
    },
    methods: {
        // 打开本地图片剪裁框
        openLocalGallery() {
            this.$refs.localCropper.openDialog()
        },
        // 开启/关闭封面引导
        switchStatus() {
            let status = !this.guideCover.isopencover ? 1 : 0
            let tip = !this.guideCover.isopencover ? '开启引导封面' : '关闭引导封面'
            this.$confirm(`确定${tip}？`, '提示', {
                cancelButtonText: '取消',
                confirmButtonText: '确定'
            }).then(() => {
                this._editStatus(status, tip)
            })
        },
        // 提交关闭/开启封面引导
        _editStatus (status, tip) {
            this.setLoading(true)
            editVliveGuideCoverStatus({
                data: {
                    assetinnerid: this.vliveModel.assetinnerid,
                    settingType: this.settingType,
                    settingValue: status
                },
                success: data => {
                    this.$message.success(`${tip}成功！`)
                    this.guideCover.isopencover = !this.guideCover.isopencover
                    this.setVliveModelGuideCover(Object.assign({}, this.guideCover))
                    this.setLoading(false)
                },
                error: data => {
                    this.guideCover.isopencover = !this.guideCover.isopencover
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 提交封面引导信息
        _editGuideCover (file) {
            this.timestamp = new Date().getTime()
            this.setLoading(true)
            editVliveGuideCover({
                data: {
                    assetinnerid: this.vliveModel.assetinnerid,
                    coverPicture: formatFileInfo(file)
                },
                success: data => {
                    this.$message.success('保存成功！')
                    this.guideCover.coverPicture = file
                    this.setVliveModelGuideCover(Object.assign({}, this.guideCover))
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setVliveModelGuideCover',
            'setLoading'
        ])
    },
    filters: {},
    watch: {
        vliveModel: {
            handler: function() {
                this.guideCover = Object.assign({}, this.vliveModel.guideCover)
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters([
            'vliveModel'
        ])
    },
    components: {
        LocalCropper
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.vliveGuideCover {
    .guide-cover{
        margin-top: 30px;
        .icon{
            margin-bottom: 20px;
        }
        .icon, .avatar-uploader{
            box-sizing: border-box;
            height: 400px;
            width: 250px;
        }
    }
}
</style>
